import { render, staticRenderFns } from "./SelectCascaderView.vue?vue&type=template&id=cb2b42e4&scoped=true"
import script from "./SelectCascaderView.vue?vue&type=script&lang=js"
export * from "./SelectCascaderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2b42e4",
  null
  
)

export default component.exports